module.exports = "/_next/static/images/VI-853d27ae558811319663706325ef42e4.png";